<template>
  <button :disabled="disabled" class="v-btn" ref="vBtn">
    <slot />
  </button>
</template>

<script>
export default {
  name: "v-btns",
  props: {
    className: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.className) {
      this.$refs.vBtn.classList.add(this.className);
    }
  },
  methods: {
    btnClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss">
.v-btn {
  -webkit-tap-highlight-color: transparent;
}
</style>
